import React, { useState } from 'react';
import './interactive.css';

const MOCK_MATCHES = [
  {
    id: 1,
    teamA: 'G2 Gozen',
    teamB: 'Karmine Corp GC',
    time: 'Vandaag 19:00 CEST',
    status: 'LIVE',
    stream: 'twitch.tv/rsemearc',
    stage: 'EMEA Game Changers Finals'
  },
  {
    id: 2,
    teamA: 'GIANTX GC',
    teamB: 'BBL Queens',
    time: 'Morgen 18:00 CEST',
    status: 'UPCOMING',
    stream: 'twitch.tv/rsemearc',
    stage: 'Lower Bracket Round 3'
  },
  {
    id: 3,
    teamA: 'FALCONS VEGA',
    teamB: 'Team Liquid Brazil',
    time: '24 Okt 20:30 CEST',
    status: 'UPCOMING',
    stream: 'twitch.tv/rsemearc',
    stage: 'Showmatch Series'
  }
];

const RscPreview = () => {
  const [activeTab, setActiveTab] = useState('schedule');

  return (
    <div className="interactive-box">
      <div className="interactive-header">
        <div className="interactive-title">
          <i className="fas fa-trophy" style={{ color: '#10b981' }}></i> Trailblazer Initiative – RSC EMEA Broadcast Layer
        </div>
        <div>
          <a 
            href="https://rscompetitions.org" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: '#38bdf8', fontSize: '0.75rem', textDecoration: 'none', fontWeight: 600 }}
          >
            rscompetitions.org <i className="fas fa-external-link-alt"></i>
          </a>
        </div>
      </div>

      <div className="interactive-content">
        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.25rem' }}>
          <button 
            type="button" 
            className={`ansible-btn ${activeTab === 'schedule' ? '' : 'ansible-btn--secondary'}`}
            style={{ padding: '0.45rem 1rem', fontSize: '0.8rem' }}
            onClick={() => setActiveTab('schedule')}
          >
            <i className="fas fa-calendar-alt"></i> Match Hub Preview
          </button>
          <button 
            type="button" 
            className={`ansible-btn ${activeTab === 'live' ? '' : 'ansible-btn--secondary'}`}
            style={{ padding: '0.45rem 1rem', fontSize: '0.8rem' }}
            onClick={() => setActiveTab('live')}
          >
            <i className="fas fa-globe"></i> Live Website Embed
          </button>
        </div>

        {activeTab === 'schedule' && (
          <div className="rsc-preview">
            <p style={{ fontSize: '0.84rem', color: 'var(--text-color)', margin: 0 }}>
              Live competitie- en uitzendschema met automatische Twitch livestream integratie en admin beheer:
            </p>
            <div className="rsc-matches-grid">
              {MOCK_MATCHES.map((m) => (
                <div key={m.id} className="rsc-match-card">
                  <div className="rsc-match-status">
                    {m.status === 'LIVE' ? (
                      <>
                        <span className="rsc-live-dot"></span> NU LIVE OP TWITCH
                      </>
                    ) : (
                      <span style={{ color: '#0284c7' }}><i className="fas fa-clock"></i> {m.time}</span>
                    )}
                  </div>
                  <div className="rsc-match-teams">
                    <span>{m.teamA}</span>
                    <span style={{ opacity: 0.5 }}>vs</span>
                    <span>{m.teamB}</span>
                  </div>
                  <div className="rsc-match-info">
                    {m.stage}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}



        {activeTab === 'live' && (
          <div className="rsc-iframe-shell">
            <iframe 
              src="https://rscompetitions.org" 
              title="RS Competitions Live" 
              className="rsc-iframe"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RscPreview;
